import React from 'react';
import { useNavigate } from 'react-router-dom';
import './SBSBadge.css';

function SBSBadge() {
  const navigate = useNavigate();

  return (
    <div className="sbs-badge" onClick={() => navigate('/')}>
      SBS
    </div>
  );
}

export default SBSBadge;

